import React from "react";
import { ViewMoreNews } from "../../pages";
import { toJS } from "mobx";
import { adminStore } from "../../stores";

const ViewMoreNewsContainer = () => {
  return <ViewMoreNews selectedNews={toJS(adminStore.singleNews)} />;
};

export default ViewMoreNewsContainer;
